import { render, staticRenderFns } from "./QNewRecruitsDrilldown.vue?vue&type=template&id=3afa1f6e&scoped=true&"
import script from "./QNewRecruitsDrilldown.vue?vue&type=script&lang=js&"
export * from "./QNewRecruitsDrilldown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afa1f6e",
  null
  
)

export default component.exports